import React, { useState, useMemo } from 'react'
import './staff.scss'
import Tab, { TabItem } from '@/components/tab/tab'
import { getBEMCls } from '@/utils/classname'
import { MainHeader, Column, Expaned } from '@/components/layout/layout'
import StaffContent, { STAFF_LIST, STAFF_OPERATE_RECORD, STAFF_APPLY_RECORD } from './router'
import { RouteComponentProps } from 'react-router'
import { useRequest } from 'ahooks'
import { $post } from '@/api'
import { staffListModel } from './staff-list/model'
import { observer } from 'mobx-react'

const PurchaseManage = observer((props: RouteComponentProps) => {
    const [appluyNum, setAppluyNum] = useState<number>(0)

    const tabList: TabItem[] = useMemo(
        () => [
            {
                id: 0,
                name: '员工列表',
                route: STAFF_LIST,
            },
            {
                id: 1,
                name: '操作记录',
                route: STAFF_OPERATE_RECORD,
                perssion: 45,
            },
            {
                id: 2,
                name: '申请记录',
                route: STAFF_APPLY_RECORD,
                count: appluyNum,
            },
        ],
        [appluyNum],
    )

    useRequest(
        () =>
            $post({
                url: '/staff/getstaffapplicationcount',
            }),
        {
            onSuccess: res => {
                setAppluyNum(res.count)
            },
            refreshDeps: [staffListModel.isUpdateApplyNum],
        },
    )

    const getCls = (el?: string, m?: string) => getBEMCls('staff-manage', el, m)

    return (
        <Column className={getCls()}>
            <MainHeader>
                <Tab tabList={tabList} />
            </MainHeader>
            <Expaned className={getCls('content')}>
                <StaffContent {...props} />
            </Expaned>
        </Column>
    )
})

export default PurchaseManage
